import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async create ({ state, commit, dispatch }) {
    try {
      const params = {
        user: state.userId,
        status: state.status,
        memo: state.memo
      }

      const { data } = await directus.createItem('member_seating_status', params)

      commit('setAttr', {
        name: 'model',
        value: data
      })
      dispatch('set')

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
